"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const AbstractInitializer_1 = __importDefault(require("../AbstractInitializer"));
const arrayMaker_1 = require("../../../../Util/arrayMaker");
const asyncIterate_1 = __importDefault(require("../../../../Util/asyncIterate"));
const getRecoveryIterator_1 = __importDefault(require("../Maker/getRecoveryIterator"));
const getSleepRangeIterator_1 = __importDefault(require("../Maker/getSleepRangeIterator"));
const getProgressIterator_1 = __importDefault(require("../Maker/getProgressIterator"));
const TrainingInterface_1 = require("../../../../BusinessLogicLayer/TrainingInterface");
class RecoveryInitializer extends AbstractInitializer_1.default {
    constructor(cache, recoveryModel, dateTimeProvider, dateTimeModifier, customerRepository) {
        super("recovery_initializer", cache);
        this.initialize = async () => {
            const recoveryIterator = (0, getRecoveryIterator_1.default)();
            const sleepRangeIterator = (0, getSleepRangeIterator_1.default)();
            const progressIterator = (0, getProgressIterator_1.default)();
            const currentDate = this.dateTimeProvider.currentDate();
            await (0, asyncIterate_1.default)(await this.customerRepository.getCustomers(), async (customer) => {
                const daysDiff = Math.abs(this.dateTimeModifier.daysDiff(customer.subscriptionPeriod.startDate, currentDate)) + 1;
                const recoveryDays = await (0, arrayMaker_1.asyncArrayMaker)(daysDiff, async (index) => {
                    const date = await this.dateTimeProvider.fromDateTimeToDate(this.dateTimeModifier.modifyDays(customer.subscriptionPeriod.startDate, index));
                    return {
                        date,
                        dayType: TrainingInterface_1.WeekDayType.TRAINING_DAY,
                        recovery: {
                            heartBeat: recoveryIterator.next(),
                            sleepHours: recoveryIterator.next(),
                            sleepHoursRange: sleepRangeIterator.next(),
                            sleepQuality: recoveryIterator.next(),
                            muscleStrain: recoveryIterator.next(),
                            stressLevel: recoveryIterator.next(),
                        },
                        progress: {
                            motivation: {
                                value: recoveryIterator.next(),
                                reason: "",
                            },
                            training: progressIterator.next(),
                            lesson: progressIterator.next(),
                            water: progressIterator.next(),
                            supplements: progressIterator.next(),
                            nutrition: progressIterator.next(),
                        },
                    };
                });
                await (0, asyncIterate_1.default)(recoveryDays, async (recoveryDay) => this.recoveryModel.setDay(customer.id, recoveryDay));
            });
        };
        this.dateTimeProvider = dateTimeProvider;
        this.dateTimeModifier = dateTimeModifier;
        this.recoveryModel = recoveryModel;
        this.customerRepository = customerRepository;
    }
}
exports.default = RecoveryInitializer;
//# sourceMappingURL=RecoveryInitializer.js.map